if (!customElements.get('mk-mobile-sticky-atc')) {
  customElements.define(
    'mk-mobile-sticky-atc',
    class MkMobileStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`);
        this.button = this.querySelector('.mk-mobile-sticky-atc__button');
        this.price = this.querySelector('.mk-mobile-sticky-atc__price');
        this.image = this.querySelector('.mk-mobile-sticky-atc__image');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        if (!this.productInfo || !this.button) return;

        this.onClick = this.handleClick.bind(this);
        this.onViewportChange = this.requestVisibilityUpdate.bind(this);
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange, { passive: true });
        this.mobileQuery.addEventListener?.('change', this.onViewportChange);

        this.observer = new MutationObserver(() => {
          this.syncFromMainForm();
          this.requestVisibilityUpdate();
        });
        this.observer.observe(this.productInfo, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }

        this.removeAttribute('hidden');
        this.syncFromMainForm();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
        this.mobileQuery?.removeEventListener?.('change', this.onViewportChange);
        this.observer?.disconnect();
        this.unsubscribeVariant?.();
        cancelAnimationFrame(this.visibilityFrame);
        document.body.classList.remove('mk-mobile-atc-visible');
      }

      get mainButton() {
        return this.productInfo?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
      }

      handleClick() {
        const mainButton = this.mainButton;
        if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
        mainButton.click();
      }

      handleVariantChange(event) {
        if (event?.data?.sectionId !== this.sectionId) return;
        this.syncFromMainForm();
      }

      syncFromMainForm() {
        const mainButton = this.mainButton;
        if (!mainButton) return;

        const mainLabel = mainButton.querySelector('span');
        const stickyLabel = this.button.querySelector('span');
        if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();

        const busy = mainButton.getAttribute('aria-disabled') === 'true' || mainButton.classList.contains('loading');
        this.button.disabled = mainButton.disabled || busy;
        this.button.setAttribute('aria-busy', busy ? 'true' : 'false');

        const priceRoot = this.productInfo.querySelector(`#price-${this.sectionId}`);
        const currentPrice =
          priceRoot?.querySelector('.price--on-sale .price-item--sale') ||
          priceRoot?.querySelector('.price__regular .price-item--regular') ||
          priceRoot?.querySelector('.price-item--regular');
        if (currentPrice && this.price) this.price.textContent = currentPrice.textContent.trim();

        const activeImage = this.productInfo.querySelector('.product__media-item.is-active img, .product__media-item:first-child img');
        if (activeImage && this.image) {
          this.image.removeAttribute('srcset');
          this.image.src = activeImage.currentSrc || activeImage.src;
          this.image.alt = activeImage.alt || '';
        }
      }

      requestVisibilityUpdate() {
        cancelAnimationFrame(this.visibilityFrame);
        this.visibilityFrame = requestAnimationFrame(() => this.updateVisibility());
      }

      updateVisibility() {
        const mainButton = this.mainButton;
        const shouldShow = Boolean(
          this.mobileQuery.matches && mainButton && mainButton.getBoundingClientRect().bottom < 0
        );

        this.classList.toggle('is-visible', shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        document.body.classList.toggle('mk-mobile-atc-visible', shouldShow);
      }
    }
  );
}
